/**
 * VIVISHOT Shopify Theme JavaScript - REPAIRED & SYNCED
 */

;(() => {
  const $ = (selector, parent = document) => parent.querySelector(selector)
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)]

  const debounce = (fn, delay) => {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => fn(...args), delay)
    }
  }

  // === HEADER LOGIC ===
  const initHeader = () => {
    const header = $("[data-sticky-header]")
    const menuBtn = $("[data-menu-toggle]")
    const mobileMenu = $("[data-mobile-menu]")
    if (!header) return

    let lastScrollY = window.scrollY
    window.addEventListener("scroll", debounce(() => {
      const currentScrollY = window.scrollY
      header.classList.toggle("header--hidden", currentScrollY > lastScrollY && currentScrollY > 100)
      lastScrollY = currentScrollY
    }, 10), { passive: true })

    if (menuBtn && mobileMenu) {
      menuBtn.addEventListener("click", () => {
        const isOpen = menuBtn.getAttribute("aria-expanded") === "true"
        menuBtn.setAttribute("aria-expanded", !isOpen)
        mobileMenu.setAttribute("aria-hidden", isOpen)
        document.body.style.overflow = isOpen ? "" : "hidden"
      })
    }
  }

  // === HERO CAROUSEL ===
  const initHeroCarousel = () => {
    const carousel = $("[data-hero-carousel]")
    if (!carousel) return
    const track = $("[data-track]", carousel)
    const slides = $$("[data-slide]", carousel)
    const dots = $$("[data-dot]", carousel)
    let currentIndex = 0

    const updateSlide = (index) => {
      currentIndex = index
      track.style.transform = `translateX(-${currentIndex * 332}px)`
      dots.forEach((dot, i) => dot.classList.toggle("hero-turntable__dot--active", i === currentIndex))
      slides.forEach((slide, i) => slide.classList.toggle("hero-turntable__slide--active", i === currentIndex))
    }

    dots.forEach((dot, i) => dot.addEventListener("click", () => updateSlide(i)))
    updateSlide(0)
  }

  // === REPAIRED CART DRAWER SYSTEM ===
  const initCartDrawer = () => {
    // REPAIR: Link to the specific ID and global functions used in theme.liquid
    const cartToggles = $$("[data-cart-toggle], .header__cart-trigger, #cart-icon-bubble")
    const cartCloseButtons = $$("[data-cart-close], .cart-drawer__close")

    cartToggles.forEach(btn => btn.addEventListener("click", (e) => {
      e.preventDefault()
      if (typeof window.openCart === 'function') window.openCart()
    }))

    cartCloseButtons.forEach(btn => btn.addEventListener("click", () => {
      if (typeof window.closeCart === 'function') window.closeCart()
    }))
  }

  // === REPAIRED ADD TO CART ACTION ===
  const initAddToCart = () => {
    const addButtons = $$("[data-add-bundle], [data-add-product], .product-card__btn")

    addButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        const originalText = btn.textContent
        btn.textContent = window.VIVISHOT?.locale === "sq" ? "U shtua!" : "Added!"
        btn.disabled = true

        // NOTE: No manual drawer call here.
        // The MutationObserver in theme.liquid handles auto-opening upon success.
        
        setTimeout(() => {
          btn.textContent = originalText
          btn.disabled = false
        }, 1500)
      })
    })
  }

  // === COUNTDOWN TIMER ===
  const initCountdown = () => {
    const timer = $("[data-countdown]")
    if (!timer) return
    const daysFromData = parseInt(timer.dataset.days || "5")
    const targetDate = new Date()
    targetDate.setDate(targetDate.getDate() + daysFromData)

    const update = () => {
      const now = new Date().getTime()
      const diff = targetDate.getTime() - now
      if (diff < 0) return
      
      const d = Math.floor(diff / (1000 * 60 * 60 * 24))
      const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const s = Math.floor((diff % (1000 * 60)) / 1000)

      if($("[data-countdown-days]", timer)) $("[data-countdown-days]", timer).textContent = d.toString().padStart(2, '0')
      if($("[data-countdown-hours]", timer)) $("[data-countdown-hours]", timer).textContent = h.toString().padStart(2, '0')
      if($("[data-countdown-minutes]", timer)) $("[data-countdown-minutes]", timer).textContent = m.toString().padStart(2, '0')
      if($("[data-countdown-seconds]", timer)) $("[data-countdown-seconds]", timer).textContent = s.toString().padStart(2, '0')
    }
    setInterval(update, 1000)
    update()
  }

  // === FLOATING INGREDIENTS ===
  const initFloatingIngredients = () => {
    const container = $(".hero-turntable__ingredients") || $(".hero-floating-ingredients")
    if (!container) return
    const emojis = ["🍋", "🍯", "🌿", "🧪"]

    setInterval(() => {
      const el = document.createElement("div")
      el.className = "floating-ingredient"
      el.textContent = emojis[Math.floor(Math.random() * emojis.length)]
      el.style.left = Math.random() * 100 + "%"
      el.style.animationDuration = (6 + Math.random() * 4) + "s"
      container.appendChild(el)
      setTimeout(() => el.remove(), 10000)
    }, 2000)
  }

  // INITIALIZE EVERYTHING
  const init = () => {
    initHeader()
    initHeroCarousel()
    initCountdown()
    initCartDrawer()
    initAddToCart()
    initFloatingIngredients()
    
    // Smooth Scroll logic
    $$('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          window.scrollTo({
            top: target.offsetTop - 80,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init()
})()